module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Black-Alphabetic.653050d0.woff2";